import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterDropdownComponent } from '../../../components/filter-dropdown/filter-dropdown.component';
import { ResetFilterButtonComponent } from '../../../components/reset-filter-button/reset-filter-button.component';
import { SavedViewOption, SavedViewsMenuComponent } from '../../../shared/saved-views/saved-views-menu.component';
import { TagFilterComponent, TagFilterOption } from '../../../components/tag-filter/tag-filter.component';

export interface FilterOption {
  value: string;
  label: string;
}

export type TestCaseFilterKey = 'status' | 'execution' | 'priority' | 'author';

export interface FilterChange {
  key: TestCaseFilterKey;
  value: string | null;
}

@Component({
  selector: 'app-test-case-filter-bar',
  standalone: true,
  imports: [
    TranslatePipe,
    FilterDropdownComponent,
    TagFilterComponent,
    ResetFilterButtonComponent,
    SavedViewsMenuComponent,
  ],
  templateUrl: './test-case-filter-bar.component.html',
  styleUrl: './test-case-filter-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestCaseFilterBarComponent {
  readonly statusOptions = input<FilterOption[]>([]);
  readonly executionOptions = input<FilterOption[]>([]);
  readonly priorityOptions = input<FilterOption[]>([]);
  readonly authorOptions = input<FilterOption[]>([]);

  readonly selectedStatus = input<string[]>([]);
  readonly selectedExecution = input<string[]>([]);
  readonly selectedPriority = input<string[]>([]);
  readonly selectedAuthor = input<string[]>([]);

  readonly tags = input<TagFilterOption[]>([]);
  readonly tagFilter = input<string[]>([]);

  readonly savedViews = input<SavedViewOption[]>([]);
  readonly activeSavedView = input<string | null>(null);
  readonly projectId = input.required<string>();

  /** Steuert die Sichtbarkeit des Reset-Buttons (NEX-1057 Review). */
  readonly hasActiveFilters = input<boolean>(false);

  readonly filterChange = output<FilterChange>();
  readonly tagChange = output<string[]>();
  readonly resetFilters = output<void>();
  readonly savedViewSelected = output<string>();
  readonly savedViewSaved = output<string>();
  readonly savedViewDeleted = output<string>();
  readonly savedViewDeleteFailed = output<string>();

  readonly statusValue = computed(() => this.selectedStatus()[0] ?? '');
  readonly executionValue = computed(() => this.selectedExecution()[0] ?? '');
  readonly priorityValue = computed(() => this.selectedPriority()[0] ?? '');
  readonly authorValue = computed(() => this.selectedAuthor()[0] ?? '');

  onChange(key: TestCaseFilterKey, raw: string): void {
    this.filterChange.emit({ key, value: raw || null });
  }

  onSavedViewSelected(name: string): void {
    this.savedViewSelected.emit(name);
  }

  onSavedViewSaved(name: string): void {
    this.savedViewSaved.emit(name);
  }

  onSavedViewDeleted(name: string): void {
    this.savedViewDeleted.emit(name);
  }

  onSavedViewDeleteFailed(name: string): void {
    this.savedViewDeleteFailed.emit(name);
  }
}
